<!-- Live text OFF: full-panel state -->
<div class="ts-panel" *ngIf="showPanel" aria-live="polite">
    <ng-container [ngSwitch]="effectiveStatus">

        <ng-container *ngSwitchCase="'listening'">
            <!-- <span class="ts-chip" *ngIf="elapsed">REC {{ elapsed }}</span> -->
            <div class="ts-orb">
                <i class="ts-ring"></i><i class="ts-ring r2"></i><i class="ts-ring r3"></i>
                <div class="ts-core">
                    <div class="ts-eq"><i></i><i></i><i></i><i></i><i></i></div>
                </div>
            </div>
            <div class="ts-title">Listening<span class="ts-dots"><b>.</b><b>.</b><b>.</b></span></div>
            <div class="ts-msgs">
                <p>Speak naturally. I'm capturing every detail.</p>
                <p>Pauses are fine. I'll keep listening.</p>
                <p>Live text is hidden, but nothing is missed.</p>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'processing'">
            <div class="ts-orb">
                <i class="ts-spin"></i>
                <div class="ts-core soft"><span class="ts-bd"><i></i><i></i><i></i></span></div>
            </div>
            <div class="ts-title">Finishing up</div>
            <p class="ts-sub">Transcribing the last bit. Just a few seconds.</p>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <ng-container *ngIf="hasTranscript; else empty">
                <div class="ts-orb">
                    <i class="ts-ring"></i>
                    <div class="ts-core"><mat-icon>check</mat-icon></div>
                </div>
                <div class="ts-title">Transcript ready</div>
                <p class="ts-sub">Ready to generate clinical notes.</p>
                <button type="button" class="ts-peek" aria-label="View transcript" (click)="peek = true">
                    <mat-icon>visibility</mat-icon><span>View transcript</span>
                </button>
            </ng-container>
            <ng-template #empty>
                <button type="button" class="ts-mic" aria-label="Start recording" (click)="micClick.emit()"
                    matTooltip="Start recording">
                    <div class="ts-orb">
                        <div class="ts-core ghost breathe"><mat-icon>mic</mat-icon></div>
                    </div>
                </button>
                <div class="ts-title">Ready when you are</div>
                <p class="ts-sub">Tap the mic to start recording your consultation.</p>
            </ng-template>
        </ng-container>

    </ng-container>
</div>

<!-- Live text ON: overlay hints on top of the textarea -->
<ng-container *ngIf="liveText && effectiveStatus">
    <div class="ts-skel" *ngIf="effectiveStatus === 'listening' && !hasTranscript" aria-hidden="true">
        <span style="width:92%"></span><span style="width:78%"></span>
        <span style="width:86%"></span><span style="width:54%"></span>
    </div>
    @if(provider !=='azure'){
    <div class="ts-pill" aria-live="polite">
        <span class="ts-bd"><i></i><i></i><i></i></span>
        {{ pillText }}
    </div>
    }
    <!-- <div class="ts-bar"><i></i></div> -->
</ng-container>